<!--<div class="toolbar"></div>-->
<!--<div style="font-size: 200%">{{ 'this page does not exist.' | language:'error':languageService.selectedLanguage }}</div><br>-->
<!--<a class="GoToLogPanel" routerLink="/sign-in">{{ 'go to log in panel' | language:'error':languageService.selectedLanguage }}</a>-->
<br>
<ng-container>
  <mat-toolbar style="padding: 16px; white-space: initial; height: auto; letter-spacing: 2px; font-size: 20px; background: var(--background); color: var(--text); justify-content: center; border: 1px solid var(--border-color); border-radius: 4px"><b style="opacity: 0.5">Ta strona nie istnieje, kliknij <a routerLink="/">tutaj</a> aby wrócić</b></mat-toolbar>
</ng-container>
